module.exports = __webpack_public_path__ + "img/2tgiv-e80-1040.prt.7754805a.jpg";